<template>
    <website-page>
        <digital-signage-navigation></digital-signage-navigation>

        <div id="home" class="main-section video">
            <video ref="video" class="main-video" autoplay loop muted playsinline preload="auto"
                   :src="videoSrc" :poster="videoPoster" :controls="isMobileLayout"
            ></video>

            <div v-if="!isMobileLayout" class="titles">
                <h1 style="width: 540px;">
                    <span v-tr>Discover 3D Holograms|Découvrez les hologrammes 3D</span>
                </h1>
                <br>
                <h2 class="subtitle blured" v-tr>Display incredibly realistic 3D holographic visuals|Affichez des visuels holographiques 3D incroyablement réalistes</h2>

                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#presentation'" variant="outline-light"><span v-tr>Learn more|En savoir plus</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </div>
        </div>

        <div id="presentation" class="page text-center">
            <div class="container mx-auto">
                <b-img fluid rounded class="mb-3" :src="require('../../assets/img/examples/hypervsn-wall.jpg')" alt="Digital Signage with Holograms"></b-img>
                <h2 v-tr>Enter a new Era of Digital Signage|Entrez dans une nouvelle ère d'affichage numérique</h2>
                <p v-if="isFrench()">
                    Eye-In Média lance la première génération d'écrans holographiques 3D au Canada thanks.
                    Cette solution unique permet de gérer, créer et afficher des visuels 3D ultra réalistes qui semblent suspendus dans les airs.
                    <br><br>
                    Cette <b>technologie sans précédent</b> fait passer votre marque au niveau suivant, et offre une expérience immersive et inspirante à vos visiteurs.
                    <br><br>
                    Eye-In Média est renommée pour ses solutions marketing et technologiques haut de gamme en affichage numérique, menu numériques et WiFi Intelligent.
                    Ce nouvel ajout complémente la suite infonuagique d'Eye-In qui permet aux marketeurs de communiquer avec ses clients en <b>créant des expériences mémorables</b>.
                </p>
                <p v-else>
                    Eye-In Media launched the world’s first Holographic 3D Display in Canada.
                    This unique solution enables you to manage, create and display incredibly realistic 3D holographic visuals that appear to be floating in mid-air.
                    <br>
                    <br>
                    This <b>unparalleled technology</b> takes your brand engagement to the next level, providing an immersive and awe-inspiring experience to viewers.
                    <br>
                    <br>
                    Eye-In Media is renowned for its world-class marketing and technology solutions in Digital Signage, Digital Menu Board and Smart WiFi.
                    This addition compliments Eye-In’s suite of cloud-based applications that enable marketers to communicate with shoppers <b>by creating memorable experiences</b>.
                </p>
            </div>

            <p class="lead font-weight-normal mb-4" v-tr>Discover our turn-key packages to buy or rent|Découvrez nos packages et forfaits de location clé en main</p>
            <b-btn variant="light" v-scroll-to="'#contact-us'" v-tr>Contact Us|Contactez-nous</b-btn>
        </div>

        <div id="how-does-it-work" class="px-3 px-md-5 text-center" style="background-color: #0b0b0b">
            <b-row class="container mx-auto">
                <b-col cols="12" md="6" class="pt-xs-3 text-light" style="padding-top: 40px;">
                    <h3 v-tr>How does it work?|Comment ça fonctionne?</h3>
                    <p v-tr>
                        Our 3D Holographic System display a four-ray rotor that spins fast at a speed of 30 frames per second. Your eyes won’t see any rays though, only your stunning 3D content floating in mid-air.|
                        Nos écrans holographiques 3D utilisent quatre rayons qui tournent pour afficher 30 images par secondes. Vos yeux ne verrons pas les rayons, seulement votre contenu suspendu dans l'air.
                    </p>

                    <a v-scroll-to="'#contact-us'" class="btn btn-primary mt-3" v-tr>More information|Plus d'informations</a>
                </b-col>
                <b-col cols="12" md="6">
                    <b-img fluid v-if="isMobileLayout" center class="mt-3" :src="require('../../assets/img/features/hologram-concept.jpg')" alt="3D Holograms Behavior Hypervsn"></b-img>
                    <b-img width="400" v-else center class="device-image" :src="require('../../assets/img/features/hologram-concept.jpg')" alt="3D Holograms Behavior Hypervsn"></b-img>
                </b-col>
            </b-row>
        </div>

        <div id="use-cases" class="p-3 p-md-5 text-center bg-light">
            <h2 class="text-uppercase mb-4" v-tr>Use Cases|Exemples d'utilisations</h2>
            <b-tabs cards align="center" class="mx-auto" style="max-width: 1280px;">
                <b-tab :title="'Merchandising|Marchandisage'|tr">
                    <h3 v-tr>Merchandising|Marchandisage</h3>
                    <p class="lead" v-tr>
                        Put your best product in the eye of your customers. Hard to miss, impossible to resist!|
                        Mettez vos produits phares en vedettes pour vos clients. Impossible de ne pas les remarquer!
                    </p>
                    <video playsinline
                           src="https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/real_retail.mp4"
                           loop autoplay muted></video>
                </b-tab>
                <b-tab :title="'Impress|Impressionnez'|tr">
                    <h3 v-tr>Impress your audience now!|Impressionnez votre audience à coup sûr!</h3>
                    <p class="lead" v-tr>
                        Present your brand in a new fashion to your customers|Présentez votre marque de façon
                        révolutionnaire à vos clients.
                    </p>
                    <video playsinline
                           src="https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/fashion.mp4"
                           loop autoplay muted></video>
                </b-tab>
                <b-tab :title="'Events|Évènements'|tr">
                    <h3 v-tr>Events|Évènements</h3>
                    <p class="lead" v-tr>
                        Mesmerize audiences with holographic visuals floating in mid-air.|
                        Laissez un souvenir impérissable grâce à des visuels holographiques suspendus dans l'air.
                    </p>
                    <video playsinline
                           src="https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/Product_launches.mp4"
                           loop autoplay muted></video>
                </b-tab>
                <b-tab :title="'Advertising|Publicité'|tr">
                    <h3 v-tr>Advertising|Publicité</h3>
                    <p class="lead" v-tr>
                        Lead the way to a new solution to integrate digital content in a real environment.|
                        Soyez les premiers à utiliser une solution pour intégrer des contenus numériques dans un
                        environnement réel.
                    </p>
                    <video playsinline
                           src="https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/shopping.mp4"
                           loop autoplay muted></video>
                </b-tab>
            </b-tabs>
        </div>

        <div id="industries" class="page inverted">
            <b-container class="text-center">
                <h1 class="mx-auto">
                    <span v-tr>For which industry?|Pour quelles industries?</span>
                </h1>
                <b-tabs align="center" class="mx-auto" style="max-width: 1280px;">
                    <b-tab :title="'Retail|Vente au détail'|tr">
                        <video src="https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/shopping.mp4"
                               loop autoplay muted playsinline controls></video>
                    </b-tab>
                    <b-tab :title="'Events|Évènements'|tr">
                        <video src="https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/Product_launches.mp4"
                               loop autoplay muted playsinline controls></video>
                    </b-tab>
                    <b-tab :title="'Malls|Centre commerciaux'|tr">
                        <video src="https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/fashion.mp4"
                               loop autoplay muted playsinline controls></video>
                    </b-tab>
                    <b-tab :title="'Hotels|Hôtels'|tr">
                        <video src="https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/Model-Hostess.mp4"
                               loop autoplay muted playsinline controls></video>
                    </b-tab>
                </b-tabs>
            </b-container>
        </div>
    </website-page>
</template>

<script>

    import DigitalSignageNavigation from "@/navigation/digital-signage-navigation.vue";
    import {isFrench, translate} from "../../../vue-components/helpers/i18n";

    export default {
        name: `home`,
        components: {DigitalSignageNavigation},
        metaInfo: {
            title: translate(`3D Holographic Displays in Canada|Écrans holographiques 3D au Canada`),
                meta: [
                { name: `keywords`, content: `digital signage, hologram, 3D, screens, display, technology, hypervsn` },
                { name: `description`, content: translate(`Impress with the latest technologies, with our 3D Holographic Displays|Impressionnez avec les dernières technologies, avec nos écrans holographiques 3D`) }
            ]
        },
        data() {
            return {
                isFrench: isFrench
            }
        },
        activated() {
            if (this.$refs.video) {
                this.$refs.video.play();
            }
        },
        computed: {
            videoSrc() {
                return `https://eyeinlivestorage.blob.core.windows.net/public/only-one/videos/${this.videoSuffix}.mp4`;
            },
            videoPoster() {
                return require(`../../assets/img/video-splash/${this.videoSuffix}.jpg`);
            },
            videoSuffix() {
                if (this.isMobileLayout) {
                    if (isFrench()) {
                        return `intro-mobile-fr`;
                    } else {
                        return `intro-mobile-en`;
                    }
                } else {
                    if (isFrench()) {
                        return `intro-fr`;
                    } else {
                        return `intro-en`;
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-columns {
        column-count: 6;
    }

    .tabs {
        ::v-deep {
            .tab-pane {
                padding: 30px 10px 10px;
                background-color: white;
                border-radius: 30px;
            }
        }
    }

    @media (max-width: 520px) {
        .card-columns {
            column-count: 2;
        }
    }
</style>
